import React from 'react';
import { IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useMantineTheme } from '@mantine/core';
import { ResponsiveButton } from './ResponsiveButton';
import { useNavigate } from 'react-router-dom';
import { isDebugModeActive, toggleDebugMode } from '@services/api/axios-instance';

interface LogoutButtonProps {
  isMobile: boolean;
  isTablet: boolean;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ isMobile, isTablet }) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isDark = theme.colors.dark != null;
  const navigate = useNavigate();

  const handleLogout = () => {
    if (isDebugModeActive()) {
      toggleDebugMode();
    }

    localStorage.removeItem('token');

    navigate('/');
  };

  return (
    <ResponsiveButton
      isMobile={isMobile}
      isTablet={isTablet}
      icon={<IconLogout size={isMobile ? 16 : isTablet ? 18 : 20} />}
      label={t('header.logout')}
      variant={isDark ? 'light' : 'subtle'}
      color="red"
      onClick={handleLogout}
    />
  );
};
